module.exports = __webpack_public_path__ + "img/21d728e.png";